import React from 'react';

import { Checkbox, Grid } from '@mantine/core';

interface IPermissionContentProps {
  permissions: {
    title: string;
    permission: string;
    defaultCheckedOffBy?: string[];
  }[];
  checkedPermissions?: string[];
  disabled?: boolean;
}

const PermissionContent = ({
  permissions,
  checkedPermissions,
  disabled = false,
}: IPermissionContentProps): JSX.Element => {
  return (
    <Grid columns={10} align='center'>
      {permissions.map(perm => {
        const title = perm.title;
        const permission = perm.permission;
        const defaultCheckedOffBy = perm.defaultCheckedOffBy;
        return (
          <>
            <Grid.Col span={1}>
              <Checkbox
                value={permission}
                disabled={disabled || checkedPermissions?.some(item => defaultCheckedOffBy?.includes(item))}
              />
            </Grid.Col>
            <Grid.Col span={9}>{title}</Grid.Col>
          </>
        );
      })}
    </Grid>
  );
};

export default PermissionContent;
